var $309d73dc65f78055$exports = {};
$309d73dc65f78055$exports = {
    "dismiss": `Descartar`
};


export {$309d73dc65f78055$exports as default};
//# sourceMappingURL=es-ES.mjs.map
